/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maxprice1Inputs */

const en_maxprice1 = /** @type {(inputs: Maxprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max price`)
};

const de_maxprice1 = /** @type {(inputs: Maxprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höchstpreis`)
};

/**
* | output |
* | --- |
* | "Max price" |
*
* @param {Maxprice1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const maxprice1 = /** @type {((inputs?: Maxprice1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maxprice1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_maxprice1(inputs)
	return de_maxprice1(inputs)
});
export { maxprice1 as "maxPrice" }